/* @flow */

import { mobileBottomNavElevation } from 'src/shared/app/base/style/token/elevation';
import { lap } from '@braindate/ui/lib/token/mediaQuery';
import { mobileBarHeight } from 'src/shared/app/nav/style/nav.style';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';
import { horizontalSmallDeviceBreakpoint } from '../../style/util/responsive';

export default {
  root: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100vw',
    height: mobileBarHeight,
    zIndex: mobileBottomNavElevation,
    borderTop: ({ theme }: ThemeFunction) => `1px solid ${theme.accentColor}`,
    backgroundColor: ({ theme }: ThemeFunction) => theme.colorBase,

    [lap]: {
      display: 'none',
    },

    [horizontalSmallDeviceBreakpoint]: {
      height: 40,
    },
  },
  inner: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
};
